"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var SocialIcon_1 = __importDefault(require("./SocialIcon"));
var RegionSelector_1 = __importDefault(require("./RegionSelector"));
var Box_1 = __importDefault(require("../Box"));
var components_1 = require("./components");
var CopyRight_1 = __importDefault(require("./CopyRight"));
function MobileFooter(props) {
    var _a, _b, _c;
    var _d = props || {}, regions = _d.regions, footerRegion = _d.footerRegion, navLinks = _d.navLinks, extraLinks = _d.extraLinks, socialLinks = _d.socialLinks, copyright = _d.copyright;
    // const first = getLinks(navLinks?.[0]?.links || [], navLinks?.[2]?.links || []);
    var second = getLinks(((_a = navLinks === null || navLinks === void 0 ? void 0 : navLinks[1]) === null || _a === void 0 ? void 0 : _a.links) || [], ((_b = navLinks === null || navLinks === void 0 ? void 0 : navLinks[2]) === null || _b === void 0 ? void 0 : _b.links) || []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Grid1, null, (_c = navLinks === null || navLinks === void 0 ? void 0 : navLinks[0]) === null || _c === void 0 ? void 0 : _c.links.map(function (item) { return (react_1.default.createElement(components_1.NavLink, { key: item.text, href: item.url, style: { whiteSpace: 'nowrap' } }, item.text)); })),
        react_1.default.createElement(Grid, null, __spreadArray([], second, true).map(function (item) { return (item ? react_1.default.createElement(components_1.NavLink, { key: item.text, href: item.url }, item.text) : react_1.default.createElement("div", null)); })),
        react_1.default.createElement(SocialIcon_1.default, { socialLinks: socialLinks }),
        react_1.default.createElement(components_1.Divider, null),
        react_1.default.createElement(BottomContent, null,
            react_1.default.createElement(BottomLinkContainer, null, extraLinks === null || extraLinks === void 0 ? void 0 : extraLinks.map(function (link) { return (react_1.default.createElement(components_1.BottomNavLink, { key: link.text, href: link.url }, link.text)); })),
            react_1.default.createElement(RegionSelector_1.default, { footerRegion: footerRegion, regions: regions })),
        react_1.default.createElement(components_1.Divider, null),
        react_1.default.createElement(CopyRight_1.default, { mt: '20px', pb: '49px', copyright: copyright })));
}
var Grid = (0, styled_1.default)(Box_1.default)({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
    paddingTop: '40px',
    paddingLeft: '18px',
    paddingRight: '18px',
});
var Grid1 = (0, styled_1.default)(Box_1.default)({
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '20px',
    paddingTop: '40px',
    paddingLeft: '18px',
    paddingRight: '18px',
});
var BottomLinkContainer = (0, styled_1.default)(Box_1.default)({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '10px',
    marginBottom: '10px'
});
var BottomContent = (0, styled_1.default)(Box_1.default)({
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '20px',
    paddingBottom: '20px',
    paddingRight: '18px',
    paddingLeft: '18px',
});
function getLinks(one, two) {
    var result = [];
    var i = 0;
    while (!(i >= one.length && i >= two.length)) {
        if (i < one.length) {
            result.push(one[i]);
        }
        else {
            result.push(null);
        }
        if (i < two.length) {
            result.push(two[i]);
        }
        else {
            result.push(null);
        }
        i++;
    }
    return result;
}
exports.default = MobileFooter;
